import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    color: COLOR_PURPLE,
    fontSize: 18,
    textAlign: 'center',
    padding: theme.spacing(0, 2),
  },
  videoWrapper: {
    zIndex: 1,
  },
  video: {
    width: 250,
    marginTop: 0,
    zIndex: 2,
  },
}));
